import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Input from '../../components/UI/Input';
import Button from '../../components/UI/Button';
import * as authService from '../../services/authService';
import * as validators from '../../utils/validators';

export default function ResetPassword() {
	const { token } = useParams();
	const navigate = useNavigate();
	const [form, setForm] = useState({ password: '', confirm: '' });
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);

	function onChange(e) {
		setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
	}

	function validate() {
		const e = {};
		if (!validators.validatePassword(form.password)) e.password = 'Min 8 chars, include a number';
		if (form.password !== form.confirm) e.confirm = 'Passwords do not match';
		setErrors(e);
		return Object.keys(e).length === 0;
	}

	async function onSubmit(e) {
		e.preventDefault();
		if (!validate()) return;
		setLoading(true);
		try {
			await authService.resetPassword(token, form.password);
			toast.success('Password reset successful');
			navigate('/login');
		} catch (err) {
			toast.error(err?.response?.data?.message || 'Reset failed');
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-md bg-white shadow rounded-lg p-6">
				<h1 className="text-2xl font-bold text-center">Set new password</h1>
				<form className="mt-6 space-y-4" onSubmit={onSubmit}>
					<Input name="password" type="password" label="New Password" value={form.password} onChange={onChange} error={errors.password} required />
					<Input name="confirm" type="password" label="Confirm New Password" value={form.confirm} onChange={onChange} error={errors.confirm} required />
					<Button type="submit" loading={loading} className="w-full">
						Reset Password
					</Button>
				</form>
				<p className="mt-4 text-sm text-center">
					Back to{' '}
					<Link to="/login" className="text-primary-600 hover:underline">
						Login
					</Link>
				</p>
			</div>
		</div>
	);
}


